window.scrollToElementId = (elementId) => {
  var element = document.getElementById(elementId);
  if (!element) {
    console.warn('element was not found', elementId);
    return false;
  }
  element.scrollIntoView({ behavior: "smooth", block: "center" });
  return true;
}